import { z } from "zod";

export const createDateTimeSchema = (required: boolean) => {
  return z
    .object({
      type: z.enum(["input", "variable"]),
      date: z.string().optional(),
      time: z.string().optional(),
      value: z.string().optional(),
      node_id: z.string().optional(),
      value_type: z.enum(["field", "object", ""]).optional(),
    })
    .superRefine((data, ctx) => {
      const hasDate = data.date && data.date.trim().length > 0;
      const hasTime = data.time && data.time.trim().length > 0;
      const hasValue = data.value && data.value.trim().length > 0;

      // Validate based on type
      if (data.type === "input") {
        if (required && (!hasDate || !hasTime)) {
          ctx.addIssue({
            code: "custom",
            message: "La fecha y hora son obligatorias",
            path: ["date"],
          });
        }

        // if has date but not time, or has time but not date
        if ((hasDate && !hasTime) || (!hasDate && hasTime)) {
          ctx.addIssue({
            code: "custom",
            message: "Debe proporcionar tanto la fecha como la hora",
            path: ["date"],
          });
        }
      }

      if (data.type === "variable") {
        if (required && !hasValue) {
          ctx.addIssue({
            code: "custom",
            message: "El valor de la variable es obligatorio",
            path: ["value"],
          });
        }
      }
    });
};

export const getDateTimeDefaultValues = () => {
  return {
    type: "input",
    date: "",
    time: "",
    value: "",
    node_id: "",
    value_type: "",
  };
};
